import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DetalleFactura } from 'src/app/Models/factura/detallefactura/detalle-factura';

@Component({
  selector: 'app-pedido-index-table-row',
  templateUrl: './pedido-index-table-row.component.html',
  styleUrls: ['./pedido-index-table-row.component.css']
})
export class PedidoIndexTableRowComponent implements OnInit {

  constructor() { }
  @Input()  nombre?:string;
  @Input() detalle?:DetalleFactura= new DetalleFactura();
  ishover?:Boolean =false;
  @Output() precio_change = new EventEmitter<number>();
  @Output() cantidad_change = new EventEmitter<number>();
  @Output() delete = new EventEmitter<number>();
  @Output() prestamo = new EventEmitter<number>();
  ngOnInit() {
    
  }

  precio_changed(){
    if(this.detalle != null){
      if(this.detalle.preuni != undefined){
        if(this.detalle.preuni.trim() != ""){
          this.precio_change.emit(parseFloat(this.detalle.preuni));
        }
      }
    }
  }
  cantidad_changed(){
    if(this.detalle != null){
      if(this.detalle.cantidad != undefined){
        if(this.detalle.cantidad.trim() != ""){
          this.cantidad_change.emit(parseFloat(this.detalle.cantidad));
        }
      }
    }
  }

  deleted(){
    this.delete.emit();
  }

  setprestamo(){
    this.prestamo.emit();
  }
  mouseenter(){
    this.ishover =true;
  }
  mouseleave(){
    this.ishover = false;
  }

}
